/* eslint-disable no-unused-vars */
import styled from '@emotion/styled';
import { Space } from 'antd';
import { Link } from 'react-router-dom';
import loginBG from '../../assets/images/login_back.jpg';
import logo from '../../assets/images/logo_trans.png';
import { ROUTES } from '../../routes';
import { ORANGE, PRIMARY, YELLOW } from '../../shared/colors';
import { RegistrationForm } from './components/registrationForm';

const RegistrationContainer = styled.div`
  min-height: 100vh;
  background-image:
    linear-gradient(120deg, rgba(3, 8, 13, 0.96), rgba(4, 16, 24, 0.84) 48%, rgba(27, 12, 8, 0.78)),
    url(${loginBG});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: #fff3dc;
  font-family: Poppins-R;
  overflow: hidden;

  .signup-shell {
    position: relative;
    display: grid;
    grid-template-columns: minmax(0, 0.95fr) minmax(460px, 0.8fr);
    align-items: center;
    gap: clamp(32px, 6vw, 86px);
    min-height: 100vh;
    padding: clamp(28px, 5vw, 64px);
    isolation: isolate;
  }

  .signup-shell::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: -2;
    background:
      radial-gradient(circle at 14% 18%, rgba(255, 79, 31, 0.16), transparent 28%),
      radial-gradient(circle at 76% 20%, rgba(255, 176, 0, 0.12), transparent 24%),
      linear-gradient(90deg, rgba(255, 255, 255, 0.035) 1px, transparent 1px),
      linear-gradient(180deg, rgba(255, 255, 255, 0.026) 1px, transparent 1px);
    background-size: auto, auto, 72px 72px, 72px 72px;
  }

  .signup-watermark {
    position: absolute;
    left: -70px;
    bottom: -120px;
    z-index: -1;
    width: min(52vw, 680px);
    opacity: 0.08;
    filter: saturate(1.25);
    pointer-events: none;
  }

  .brand-panel {
    max-width: 720px;
  }

  .brand-mark {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 38px;
  }

  .brand-logo {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    object-fit: contain;
    filter: drop-shadow(0 10px 24px rgba(0, 0, 0, 0.36));
  }

  .brand-name {
    font-family: Poppins-B;
    font-size: clamp(25px, 2.5vw, 38px);
    line-height: 1;
  }

  .brand-name .orange,
  .form-brand .orange {
    color: ${ORANGE};
  }

  .brand-name .e {
    color: #fff3dc;
  }

  .form-brand .e {
    color: #0f1d29;
  }

  .brand-name .gold,
  .form-brand .gold {
    color: ${YELLOW};
  }

  .brand-title {
    max-width: 720px;
    margin: 0;
    color: #f8fafc;
    font-family: Poppins-B;
    font-size: clamp(40px, 4.6vw, 70px);
    line-height: 0.98;
    letter-spacing: 0;
  }

  .brand-copy {
    max-width: 590px;
    margin: 22px 0 0;
    color: rgba(255, 243, 220, 0.78);
    font-size: 16px;
    line-height: 1.75;
  }

  .ant-form-item-explain.ant-form-item-explain-error {
    font-size: 11px;
  }

  .forms {
    width: min(100%, 520px);
    justify-self: center;
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 18px;
    padding: 26px 28px 24px;
    background:
      linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(248, 250, 252, 0.92));
    color: #0f1d29;
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.38);
    backdrop-filter: blur(18px);
  }

  .form-brand {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
  }

  .form-brand img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: contain;
  }

  .form-brand p {
    margin: 0;
    font-family: Poppins-B;
    font-size: 21px;
    line-height: 1;
  }

  .form-heading {
    margin-bottom: 18px;
  }

  .form-heading span {
    color: #637286;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .form-heading h1 {
    margin: 4px 0 0;
    color: #0f1d29;
    font-family: Poppins-B;
    font-size: 24px;
  }

  .premium-form .form-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .premium-form .ant-form-item {
    margin-bottom: 14px;
  }

  .premium-form .ant-form-item-label > label {
    color: #334155;
    font-family: Poppins-B;
    font-size: 12px;
  }

  .premium-form .ant-input,
  .premium-form .ant-input-affix-wrapper {
    height: 42px;
    border-color: #cbd5e1 !important;
    border-radius: 8px;
    background: #f8fafc !important;
    color: #0f1d29 !important;
    box-shadow: none;
  }

  .premium-form .ant-input-affix-wrapper input {
    background: transparent !important;
    color: #0f1d29 !important;
  }

  .premium-form .ant-input-prefix {
    margin-right: 9px;
    color: #64748b;
  }

  .premium-form .ant-input-affix-wrapper-focused,
  .premium-form .ant-input:focus {
    border-color: ${ORANGE} !important;
    box-shadow: 0 0 0 3px rgba(255, 79, 31, 0.12) !important;
  }

  .signin-row {
    display: flex;
    justify-content: center;
    gap: 7px;
    margin-top: -4px;
    color: #64748b;
    font-size: 12px;
    text-align: center;
  }

  .signin-row a {
    color: ${PRIMARY};
    font-family: Poppins-B;
    text-decoration: underline;
  }

  .conditions {
    font-size: 12px;
    color: #777;
    text-align: center;
    margin: 0;
  }

  @media (max-width: 980px) {
    overflow: auto;

    .signup-shell {
      grid-template-columns: 1fr;
      gap: 30px;
      padding: 28px 18px;
    }

    .brand-panel {
      text-align: center;
      justify-self: center;
    }

    .brand-mark {
      justify-content: center;
      margin-bottom: 24px;
    }

    .brand-copy {
      margin-left: auto;
      margin-right: auto;
    }
  }

  @media (max-width: 767px) {
    .brand-title {
      font-size: 38px;
    }

    .forms {
      padding: 22px 18px;
    }

    .premium-form .form-grid {
      grid-template-columns: 1fr;
      gap: 0;
    }
  }
`;

export const RegistrationPage = () => {
  return (
    <RegistrationContainer>
      <div className='signup-shell'>
        <img className='signup-watermark' src={logo} alt='' />

        <section className='brand-panel'>
          <div className='brand-mark'>
            <img className='brand-logo' src={logo} alt='MoranjETrade' />
            <div className='brand-name'>
              <span className='orange'>Moranj</span>
              <span className='e'>E</span>
              <span className='gold'>Trade</span>
            </div>
          </div>

          <h1 className='brand-title'>
            Ouvrez votre accès au marché obligataire régional.
          </h1>

          <p className='brand-copy'>
            Rejoignez MoranjETrade pour suivre les titres, préparer vos ordres
            et accéder aux outils de marché depuis un environnement pensé pour
            les professionnels.
          </p>
        </section>

        <section className='forms'>
          <div className='form-brand'>
            <img src={logo} alt='MoranjETrade' />
            <p>
              <span className='orange'>Moranj</span>
              <span className='e'>E</span>
              <span className='gold'>Trade</span>
            </p>
          </div>

          <div className='form-heading'>
            <span>Inscription</span>
            <h1>Créer un compte</h1>
          </div>

          <RegistrationForm />
          <Space className='signin-row'>
            <p>Avez vous déjà un compte ?</p>
            <Link to={ROUTES.SIGNIN}>
              <p>Connectez vous</p>
            </Link>
          </Space>
          <p className='conditions'>
            En cliquant sur 'Créer mon compte', j'accepte les{' '}
            <a href='.'>Conditions d'Utilisations</a> de <b>MoranjEtrade</b> et
            je comprends que les informations de mon compte seront utilisées
            conformément à la <a href='.'>Politique de confidentialité</a> de
            MoranjEtrade
          </p>
        </section>
      </div>
    </RegistrationContainer>
  );
};
